import CryptoJS from "crypto-js";
// const env = process.env.NODE_ENV;
// To decrypt the payload of frontend
export const decryptMessage = (data: string) => {
  const decrypted = CryptoJS.AES.decrypt(
    data?.slice(1, -1),
    process.env.REACT_APP_KEY || "sunrise@123"
  ).toString(CryptoJS.enc.Utf8);
  return JSON.parse(decrypted);
};

// To encrypt the payload of backend
export const encryptMessage = (data: string) => {
  const encrypted = CryptoJS.AES.encrypt(
    data,
    process.env.REACT_APP_KEY || "sunrise@123"
  ).toString();
  return encrypted;
};
